import type { IconProp } from '@fortawesome/fontawesome-svg-core'
import { FontAwesomeIcon } from '@fortawesome/react-fontawesome'
import type { FC } from 'react'
import styled from 'styled-components'

const Container = styled.div<{ disabled?: boolean }>`
  display: grid;
  grid-template-columns: min-content 1fr;
  grid-gap: 5px;
  align-items: center;
  font-weight: bold;

  opacity: ${props => (props.disabled ? 0.6 : 1)};
  cursor: ${props => (props.disabled ? 'not-allowed' : 'pointer')};
`

interface Props {
  label: string
  icon: IconProp
  onClick: () => void
  disabled?: boolean
}

const ActionButton: FC<Props> = ({ label, icon, onClick, disabled }) => (
  <Container
    onClick={disabled ? () => {} : onClick}
    disabled={disabled}
    data-testid="action-button"
  >
    <FontAwesomeIcon size="1x" icon={icon} onClick={disabled ? () => {} : onClick} />{' '}
    {label}
  </Container>
)

export default ActionButton
